import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { color } from '../../../app/theme';
import TextField from '../../shared/TextField';
import RowTitle from '../RowTitle';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$3,
      marginBottom: 12,
    },
    input: {
      width: 542,
    },
    autoModeLabel: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 13,
      lineHeight: 1,
      color: color.$13,
      '& > img': {
        marginLeft: 4,
      },
    },
  },
  {
    name: 'Trigger',
  },
);

const defaultRecord = {
  weekdays: ['6', '0'],
  fromSecInDay: 0,
  toSecInDay: 86400,
  editing: true,
};

const defaultTimeZone = {
  value: 'GMT+8:00 Asia/Taipei',
  text: 'GMT +8:00（Asia/Taipei）',
  offset: '+8:00',
};

const defaultDayOfWeekActive = [
  [
    {
      fromSecInDay: 0,
      toSecInDay: 86400,
    },
  ],
  [],
  null,
  null,
  null,
  null,
  [
    {
      fromSecInDay: 0,
      toSecInDay: 86400,
    },
  ],
];

export const defaultAutoTime = {
  dayOfWeekActive: defaultDayOfWeekActive,
  records: [defaultRecord],
  timeZone: defaultTimeZone,
};

const Trigger = ({
  hitTags,
  keyword,
  onChange,
  isSaved,
  disabled,
  pathKey,
  autoTime,
  onCheckInsightArkProduct,
  openLivechatBot,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    if (!autoTime) {
      onChange({
        autoTime: defaultAutoTime,
      });
    }
  }, [autoTime]);

  useEffect(() => {
    if (!openLivechatBot) {
      onChange({
        openLivechatBot: {
          enabled: true,
        },
      });
    }
  }, [openLivechatBot]);

  return (
    <div className={classes.root}>
      <RowTitle
        title={t(`${pathKey}:triggerSettingContainer.triggerTitle`)}
        subtitle={t(`${pathKey}:triggerSettingContainer.triggerSubtitle`)}
        isRequired
      />
      <TextField
        style={{ marginBottom: 36 }}
        className={classes.input}
        type="text"
        isValid
        value={keyword || ''}
        placeholder={t(`${pathKey}:triggerSettingContainer.triggerPlaceholder`)}
        onChange={e => onChange({ keyword: e.target.value })}
        error={isSaved && !keyword}
        disabled={disabled}
      />
      <RowTitle title={t(`${pathKey}:triggerSettingContainer.triggerTags`)} />
      <TextField
        className={classes.input}
        type="text"
        isValid
        value={hitTags?.[0] || ''}
        placeholder={t(
          `${pathKey}:triggerSettingContainer.triggerTagsPlaceholder`,
        )}
        onChange={e => {
          onCheckInsightArkProduct(() => {
            onChange({ hitTags: [e.target.value] });
          });
        }}
        disabled={disabled}
      />
    </div>
  );
};

export default Trigger;
